import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Users, LogOut, BarChart2, UserPlus, Mail } from 'lucide-react';
import { ReseptioLogoFull } from './ReseptioLogo';

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: 'Genel Bakış', end: true },
  { to: '/admin/customers', icon: Users, label: 'Müşteriler' },
  { to: '/admin/signups', icon: UserPlus, label: 'Kayıtlar' },
  { to: '/admin/daily', icon: BarChart2, label: 'Günlük Rapor' },
  { to: '/admin/demo-requests', icon: Mail, label: 'Demo Talepleri' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <aside style={{ width: 240, background: '#0b1226', color: 'white', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
        <div style={{ padding: '20px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <ReseptioLogoFull height={28} style={{ marginBottom: 4 }} />
          <div style={{ fontSize: 10, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.08em', marginTop: 6 }}>
            Sistem Yönetimi
          </div>
        </div>

        <nav style={{ flex: 1, padding: '12px 8px' }}>
          {navItems.map(({ to, icon: Icon, label, end }) => (
            <NavLink key={to} to={to} end={end} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8,
              color: isActive ? 'white' : '#64748b', background: isActive ? '#f97316' : 'transparent',
              textDecoration: 'none', fontSize: 14, fontWeight: 500, marginBottom: 2, transition: 'all 0.15s',
            })}>
              <Icon size={17} />{label}
            </NavLink>
          ))}
        </nav>

        <div style={{ padding: '12px 8px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ padding: '8px 12px', marginBottom: 4, fontSize: 13, color: '#475569' }}>
            {user?.name}
          </div>
          <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px', borderRadius: 8, background: 'transparent', border: 'none', color: '#475569', cursor: 'pointer', fontSize: 14, width: '100%' }}>
            <LogOut size={15} /> Çıkış
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, overflow: 'auto', background: '#f8fafc' }}>
        <Outlet />
      </main>
    </div>
  );
}
